import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'reactstrap';
import { orderBy } from 'lodash';

import UploadPageFileGridItem from './FileGridItem';

const UploadPageFileGrid = ({
  submittedFiles,
  selectedFiles,
  ...props
}) => (
  <Row className="upload-files-wrapper gutter-20 files-grid">
    {orderBy(submittedFiles, 'batchId', 'desc').map(file => (
      <UploadPageFileGridItem
        key={file.uuid}
        file={file}
        isSelected={selectedFiles.includes(file.id)}
        {...props}
      />
    ))}
  </Row>
);

UploadPageFileGrid.propTypes = {
  submittedFiles: PropTypes.array.isRequired,
  selectedFiles: PropTypes.array.isRequired,
};

export default UploadPageFileGrid;
